// Legal text validated by legal counsel — always shown in English regardless of app locale.
// Do not run through i18n/translation.
export const PRIVACY_POLICY_CONTENT = {
  title: 'Privacy Policy – Primelis Signal',
  lastUpdated: 'Last updated: July 21, 2026',
  intro:
    'This Privacy Policy applies to Primelis ("Primelis", "we", "us", or "our") and describes how and why we collect, store, use, and share ("process") your information when you use our proprietary tool, Primelis Signal, and related services.',
  section1Title: '1. What Information Do We Collect?',
  section1ProvidedHeading: 'Personal Information Provided by You',
  section1ProvidedIntro:
    'We collect personal information that you voluntarily provide when you register for an account, inquire about our platform, or contact us directly.',
  section1AccountDataLabel: 'Account Data:',
  section1AccountDataText: 'Names and professional email addresses.',
  section1ConnectionCredentialsLabel: 'Connection Credentials:',
  section1ConnectionCredentialsText: 'Encrypted passwords and authentication tokens.',
  section1NoSensitive: 'We do not process sensitive personal information.',
  section1AutomaticHeading: 'Information Collected Automatically',
  section1AutomaticIntro:
    'When you access or navigate Primelis Signal, certain information is collected automatically for system security and diagnostic performance:',
  section1LogDataLabel: 'Log Data:',
  section1LogDataText: 'timestamped login events.',
  section1CookiesLabel: 'Cookies and Session Trackers:',
  section1CookiesText:
    'Strictly necessary technical cookies required to maintain user sessions and secure platform access.',
  section2Title: '2. How Do We Process Your Information & Global Legal Grounds?',
  section2Intro:
    'We process personal information strictly to deliver, secure, and maintain the Primelis Signal platform.',
  heading: 'User Accounts & Authentication',
  dataCollectedLabel: 'Data Collected:',
  dataCollectedText: 'User names, email addresses, and encrypted connection credentials.',
  purposeLabel: 'Purpose of Processing:',
  purposeText: 'Strictly to provision, maintain, and secure your user account and authenticate your access.',
  legalGroundsLabel: 'Legal Grounds & Global Compliance:',
  legalGroundsEu:
    'EU & UK (GDPR): Processed under the legal basis of Performance of a Contract (GDPR Article 6(1)(b)) to deliver the platform services requested by your organization.',
  legalGroundsFrance:
    'France / CNIL: Complies with French data protection standards; account provisioning does not require repeated connection pop-ups or consent banners.',
  legalGroundsLatam:
    'LATAM (e.g., Brazil LGPD): Processed under the legal basis of Execution of a Contract for secure account access.',
  legalGroundsUs:
    'United States (CCPA/CPRA & State Laws): Collected solely for essential business operations (user authentication and platform security). We do not "sell" or "share" personal information.',
  legalGroundsIsrael:
    'Israel (Protection of Privacy Law - PPL): Processed based on informed consent provided at account creation, strictly limited to user authentication.',
  legalGroundsJapan:
    'Japan (APPI): Processed based on the specified purpose of use notified at sign-up. Cross-border transfer to servers within the European Union (Belgium) is recognized under the EU-Japan mutual adequacy agreement.',
  section3Title: '3. How Long Do We Retain Your Data?',
  dataRetentionText:
    'We retain your user account data (name, email, credentials) only for as long as your user profile remains active, or until your organization requests deletion or terminates its contract/subscription with Primelis Signal.',
  section4Title: '4. Where Is Your Data Stored & Shared?',
  dataHostingLabel: 'Data Hosting Location:',
  dataHostingText:
    'Your account data is securely hosted on servers located in Belgium (European Union). Storing data within the EU guarantees compliance with European GDPR standards for all users globally.',
  thirdPartyLabel: 'Third-Party Sharing:',
  thirdPartyText:
    'We do not sell, rent, or trade your account credentials or email addresses to third parties or marketing platforms.',
  section5Title: '5. How Do We Keep Your Information Secure?',
  section5Text:
    'We maintain strict technical and organizational measures to protect your personal information, including encrypted data transmissions (SSL/TLS), hashed password storage, and multi-factor authentication (MFA) protocols where applicable.',
  section6Title: '6. Your Privacy Rights',
  section6Intro:
    'Depending on your geographic location (EU/UK, US, LATAM, Israel, Japan), you may have the right to:',
  section6Right1: 'Access, review, or obtain a copy of your personal data.',
  section6Right2: 'Request the correction or updating of incomplete or inaccurate data.',
  section6Right3: 'Request the deletion of your user account and personal data ("Right to Erasure").',
  section6Outro: 'To exercise any of these rights, please contact your dedicated support team.',
  section7Title: '7. Contact Us',
  section7Text:
    'If you have any questions or comments about this Privacy Policy or how Primelis Signal processes your information, please contact your dedicated support team.',
} as const;
